import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ReactPlayer from 'react-player';
import useThemeMediaQuery from '../../../core/hooks/useThemeMediaQuery';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 200,
  [theme.breakpoints.up('sm')]: {
    minHeight: 240,
  },
  [theme.breakpoints.up('md')]: {
    minHeight: 0,
  },
}));

const Header = () => {
  // En el celular no se carga: el video pesa 19 MB y en datos móviles se veía un bloque oscuro mientras bajaba
  const isPhone = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));
  const bannerUrl = `${process.env.PUBLIC_URL}/assets/banner.mp4`;

  if (isPhone) {
    return null;
  }

  return (
    <Root className="relative overflow-hidden flex shrink-0 items-center justify-center">
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: '100%',
          mx: 0,
          aspectRatio: '16 / 9',
          minHeight: { xs: 180, sm: 200 },
          maxHeight: { xs: 260, sm: 300, md: 380, lg: 420, xl: 460 },
          overflow: 'hidden',
          '& video': {
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          },
        }}
      >
        <ReactPlayer
          url={bannerUrl}
          width="100%"
          height="100%"
          style={{ position: 'absolute', left: 0, top: 0 }}
          muted
          playsinline
          volume={0}
          playing
          loop
          config={{
            file: {
              attributes: {
                playsInline: true,
                preload: 'metadata',
              },
            },
          }}
        />
      </Box>
    </Root>
  );
};

export default Header;
